module.exports = __webpack_public_path__ + "static/media/mobiwash-desktop-screens.a815fbc0.png";